<template lang="pug">
.v-page-section-options.page-section-options(v-if="section" )
	.container
		.page-section-options__wrap(v-if="section.items" )
			.page-section-options__card-wrap(v-for="(card, index) in section.items" :key="index" )
				.page-section-options__card.card-option
					v-svg-icon.card-option__icon(v-if="card.icon" :icon="card.icon")
					.card-option__title(v-if="card.title" ) {{ card.title }}
					template(v-if="card.buttons" )
						a.card-option__button(v-for="(button, index) in card.buttons" :class="button.class" :key="index" :href="button?.href || '#'") {{ button.text }}

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [sourceMixin],

	data() {
		return {
			section: null
		};
	},

	methods: {
		dataSet(data) {
			this.section = data;
		}
	}
};
</script>